import React, { useState, memo } from "react";
import { Paper, Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		marginBottom: "0.5em",
	},
}));

function MenuBar({ categoryHandler, categories }) {
	const classes = useStyles();
	const [value, setValue] = useState(0);
	const categoriesList = [{ name: "Todos" }, ...categories];

	const handleChange = (event, newValue) => {
		setValue(newValue);
		if (newValue !== categoriesList.length) categoryHandler(categoriesList[newValue]);
		if (newValue === categoriesList.length) categoryHandler("addCategory");
	};

	return (
		<Paper className={classes.root}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="secondary"
				textColor="secondary"
				variant="scrollable"
				scrollButtons="auto"
				aria-label="scrollable menu"
			>
				{categoriesList.map((category) => {
					return <Tab key={category.name} label={category.name} />;
				})}
				<Tab icon={<AddCircleOutlineIcon />} />
			</Tabs>
		</Paper>
	);
}
const memoBar = memo(MenuBar);
export default memoBar;
